var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import mermaid from "mermaid";
var mermaidInstance = null;
export function loadMermaid() {
    return __awaiter(this, void 0, void 0, function () {
        var mod, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (mermaidInstance)
                        return [2 /*return*/, mermaidInstance];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, import("mermaid")];
                case 2:
                    mod = _c.sent();
                    mermaidInstance = (_b = mod.default) !== null && _b !== void 0 ? _b : mod; // handles both default + named exports
                    return [2 /*return*/, mermaidInstance];
                case 3:
                    _a = _c.sent();
                    throw new Error("Mermaid diagram rendering requires the `mermaid` package. Please install it to enable diagram functionality.");
                case 4: return [2 /*return*/];
            }
        });
    });
}
export var MermaidDiagram = function (_a) {
    var code = _a.code, title = _a.title, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    var containerRef = useRef(null);
    var _d = useState("loading"), renderState = _d[0], setRenderState = _d[1];
    var _e = useState(""), content = _e[0], setContent = _e[1];
    var renderDiagram = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var diagramId, svg, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!code)
                        return [2 /*return*/];
                    setRenderState("loading");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    // Initialize mermaid with simple, safe configuration
                    mermaid.initialize({
                        startOnLoad: false,
                        theme: "default",
                        securityLevel: "loose",
                        maxTextSize: 50000,
                        maxEdges: 200,
                    });
                    diagramId = "mermaid-diagram-".concat(Date.now());
                    return [4 /*yield*/, mermaid.render(diagramId, code)];
                case 2:
                    svg = (_a.sent()).svg;
                    // Set the SVG content and mark as successful
                    setContent(svg);
                    setRenderState("success");
                    return [3 /*break*/, 4];
                case 3:
                    _error_1 = _a.sent();
                    // console.error("Mermaid rendering error:", _error);
                    setRenderState("fallback");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [code]);
    // Render diagram when code changes
    useEffect(function () {
        renderDiagram();
    }, [renderDiagram]);
    return (React.createElement("div", { className: "mermaid-diagram-container ".concat(className).trim(), style: style },
        title && React.createElement("h4", { className: "mermaid-diagram-title" }, title),
        React.createElement("div", { ref: containerRef },
            renderState === "loading" && React.createElement("div", { className: "mermaid-diagram-loading" }, "Loading diagram..."),
            renderState === "success" && (React.createElement("div", { className: "mermaid-diagram-content", dangerouslySetInnerHTML: { __html: content } })),
            renderState === "fallback" && (React.createElement("div", { className: "mermaid-diagram-error" },
                React.createElement("span", { className: "mermaid-diagram-error-title" }, "Diagram Error:"),
                " Unable to render Mermaid diagram.",
                React.createElement("br", null),
                "Please check the diagram syntax or try refreshing the page.")))));
};
export default MermaidDiagram;
